import { FC } from 'react';

import { useTheme } from 'styled-components';

import { SPACING } from '~/common/layout-propertis/spacing';

import { IFormLabelProps } from './types';
import { Container } from './styles';
import { Typography } from '../../Typography';
import { Icon } from '../../Icons';
import { Badge } from '../../Badge';

export const FormLabel: FC<IFormLabelProps> = ({
  label,
  sublabel = '',
  badge = '',
  description = '',
  isDisabled = false,
  isRequired = false,
  hint = '',
}) => {
  const theme = useTheme();

  return (
    <Container>
      <header>
        <Typography.Label
          size="small"
          color={isDisabled ? 'neutral.400' : 'neutral.0'}
        >
          {label}
        </Typography.Label>

        {isRequired && (
          <Typography.Label size="small" color="green.500">
            *
          </Typography.Label>
        )}

        {sublabel && (
          <Typography.Paragraph
            size="x-small"
            color={isDisabled ? 'neutral.500' : 'neutral.400'}
          >
            {sublabel}
          </Typography.Paragraph>
        )}

        {!!hint && (
          <Icon
            type="information-2-fill"
            size={14}
            color={theme.neutral[isDisabled ? 500 : 400]}
          />
        )}

        {!!badge && (
          <>
            {typeof badge === 'string' ? (
              <Badge
                color="blue"
                variant="light"
                text={badge}
                size="small"
                isDisabled={isDisabled}
              />
            ) : (
              <Badge {...badge} />
            )}
          </>
        )}
      </header>

      <div>
        {!!description && (
          <Typography.Paragraph
            size="x-small"
            color={isDisabled ? 'neutral.500' : 'neutral.400'}
            style={{
              marginTop: SPACING._8,
            }}
          >
            {description}
          </Typography.Paragraph>
        )}

        {/* {link && <Button href={link.href} text={link.text} />} */}
      </div>
    </Container>
  );
};
